<template>
    <div v-if="userAccount" class="player-list">
      <div class="content">
        <header>
          <h2>Available Players</h2>
        </header>
        <router-link to="/account/player/new">
          <button class="add-player"><span>Connect New Player</span></button>
        </router-link>
        <ul class="players">
          <li v-for="player in sortedPlayers" :key="player['.key']">
            <player-card :player="player"/>
          </li>
        </ul>
        <span class="nothing-found" v-if="accountPlayers.length === 0">Players not found.</span>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import firebase from '../../firebase-app'
import PlayerCard from '../elements/PlayerCard'

export default {
  created () {
    this.init()
  },
  components: { PlayerCard },
  computed: {
    ...mapState(['userAccount', 'accountPlayers']),

    accountId () {
      if (!this.userAccount) {
        return null
      }
      return this.userAccount['.key']
    },

    sortedPlayers () {
      if (!this.accountPlayers) return []
      return [...this.accountPlayers].sort((a, b) => {
        let result = a.hasOwnProperty('connections') ? -1 : 0
        result = b.hasOwnProperty('connections') ? result + 1 : result
        result = a.hasOwnProperty('artwork') ? result - 1 : result
        result = b.hasOwnProperty('artwork') ? result + 1 : result
        return result
      })
    }
  },
  methods: {
    ...mapActions(['setRef']),

    init () {
      if (this.accountId) {
        this.setRef({
          key: 'accountPlayers',
          ref: firebase.database().ref('accounts/' + this.accountId + '/players')
        })
        this.setRef({
          key: 'accountArtworks',
          ref: firebase.database().ref('accounts/' + this.accountId + '/artworks')
        })
      }
    }
  },
  watch: {
    $route () {
      this.init()
    },
    'userAccount' () {
      this.init()
    }
  }
}
</script>
<style lang="scss">
  @import "../../scss/vars";
  header {
    h2 {
      margin: 0 0 $basic-padding 0;
    }
  }
  button.add-player {
    //height: $basic-size;
    margin-bottom: $basic-size;
  }

  .players {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
  }
</style>
